import { useParams } from "react-router";
import { MainContainerWrapper, MainPadding } from "../../styles/Main.styles";
import Form from "../produk/components/Form";
import { useGetProductDetail } from "../produk/network/resolver";
import Spinner from "../../components/spinner/Spinner";
import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import HargaKhusus from "../produk/components/HargaKhusus";
import HistoryStock from "../produk/components/HistoryStock";
import TambahStock from "../produk/components/TambahStock";
import Grouping from "./components/Grouping";

export default function ProdukDetail() {
  const { id } = useParams();
  const { data: dataDetailProductRaw, isLoading: fetchDetailProduct } =
    useGetProductDetail({ productId: id });
  const dataDetailProduct = dataDetailProductRaw?.data.data;
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <MainPadding>
      <MainContainerWrapper>
        {fetchDetailProduct ? (
          <Spinner />
        ) : (
          <Box>
            <Box mb={2}>
              <Tabs
                variant="scrollable"
                value={selectedTab}
                onChange={(e, v) => setSelectedTab(v)}
              >
                <Tab label="Detail Produk" />
                <Tab label="Harga Khusus Customer" />
                <Tab label="History Stock" />
                <Tab label="Tambah Stock" />
                <Tab label="Group" />
              </Tabs>
            </Box>
            {selectedTab === 0 && (
              <Form onComplete={() => {}} product={dataDetailProduct} />
            )}
            {selectedTab === 1 && <HargaKhusus product={dataDetailProduct} />}
            {selectedTab === 2 && (
              <HistoryStock productId={dataDetailProduct?.id} />
            )}
            {selectedTab === 3 && <TambahStock product={dataDetailProduct} />}
            {selectedTab === 4 && <Grouping id={dataDetailProduct?.id} />}
          </Box>
        )}
      </MainContainerWrapper>
    </MainPadding>
  );
}
